const TWENTY_FOUR_HOURS_MS = 24 * 60 * 60 * 1000;

const accountGTMEventsMap = {
  account_update_payment_request: 'dl_ga4_account_update_payment_request',
  account_adjust_order_date_btn_clicked:
    'dl_ga4_account_adjust_order_date_btn_clicked',
  account_update_next_ship_date: 'dl_ga4_account_update_next_ship_date',
  account_update_frequency: 'dl_ga4_account_update_frequency',
  account_save_changes_from_skip_order_modal:
    'dl_ga4_account_save_changes_from_skip_order_modal',
  account_adjust_from_skip_order_modal:
    'dl_ga4_account_adjust_from_skip_order_modal',
  account_add_remove_product_btn_clicked:
    'dl_ga4_account_add_remove_product_btn_clicked',
  account_edit_my_subscription_btn_clicked:
    'dl_ga4_account_edit_my_subscription_btn_clicked',
  account_update_my_formula_btn_clicked:
    'dl_ga4_account_update_my_formula_btn_clicked',
  account_apply_changes_from_preferences_modal:
    'dl_ga4_account_apply_changes_from_preferences_modal',
  account_revert_changes_from_preferences_modal:
    'dl_ga4_account_revert_changes_from_preferences_modal',
  account_remove_product_from_sub: 'dl_ga4_account_remove_product_from_sub',
  account_product_quantity_decreased:
    'dl_ga4_account_product_quantity_decreased',
  account_product_quantity_increased:
    'dl_ga4_account_product_quantity_increased',
  account_back_button_clicked_from_adjust_order_modal:
    'dl_ga4_account_back_button_clicked_from_adjust_order_modal',
  cancel_start: 'dl_ga4_cancel_flow_start',
  cancel_complete: 'dl_ga4_cancel_flow_complete',
  cancel_send_cs: 'dl_ga4_cancel_flow_send_cs_inquiry',
  cancel_update_date: 'dl_ga4_cancel_flow_update_order_date',
  cancel_view_offer: 'dl_ga4_cancel_view_offer',
  cancel_accepted_offer: 'dl_ga4_cancel_accepted_offer',
  cancel_offer_error: 'dl_ga4_cancel_offer_error',
  cancel_switch_brand: 'dl_ga4_cancel_switch_brand',
  view_regimen_hair: 'dl_ga4_view_hair_regimen',
  view_regimen_body: 'dl_ga4_view_body_regimen',
  view_regimen_skin: 'dl_ga4_view_skin_regimen',
  add_item_regimen_hair: 'dl_ga4_add_item_hair_regimen',
  add_item_regimen_body: 'dl_ga4_add_item_body_regimen',
  add_item_regimen_skin: 'dl_ga4_add_item_skin_regimen',
  remove_item_regimen_hair: 'dl_ga4_remove_item_hair_regimen',
  remove_item_regimen_body: 'dl_ga4_remove_item_body_regimen',
  remove_item_regimen_skin: 'dl_ga4_remove_item_skin_regimen',
  expand_ingredients: 'dl_ga4_expand_ingredients_product_card',
  update_sub_frequency: 'dl_ga4_update_sub_frequency',
  update_profile: 'dl_ga4_update_profile',
  shop_all_filters_used: 'dl_ga4_shop_all_filters_used',
  shop_all_filters_reset: 'dl_ga4_shop_all_filters_reset'
};

function convertSnakeCaseToWords(inputString) {
  const str = inputString.replace(/_([a-z])/g, function (match, group1) {
    return ' ' + group1.toUpperCase();
  });

  return str.charAt(0).toUpperCase() + str.slice(1);
}

function convertCamelCaseToWords(inputString) {
  return inputString
    ? inputString.replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase()
    : '';
}

async function sleep(milliseconds) {
  return new Promise((resolve) => {
    setTimeout(resolve, milliseconds);
  });
}

function getLocalStorageWithExpiry(key) {
  const itemStr = localStorage.getItem(key);

  if (!itemStr) {
    return null; // Return null if item does not exist
  }

  const item = JSON.parse(itemStr);
  const now = new Date();

  if (now.getTime() > item.expiry) {
    localStorage.removeItem(key);
    return null;
  }

  return item.value;
}

function setLocalStorageWithExpiry(key, value, ttl) {
  const now = new Date();
  const item = {
    value: value,
    expiry: now.getTime() + ttl
  };
  localStorage.setItem(key, JSON.stringify(item));
}

function parseErrorDetailsAsHtml(errorMessage) {
  let errorDetails = '';
  if (errorMessage) {
    try {
      const errorMessageParsed = JSON.parse(errorMessage) || {};
      const errorEntries = Object.entries(errorMessageParsed);
      if (errorEntries.length > 0) {
        errorDetails = errorEntries
          .map((entry) => {
            return `<p>${entry[1]}</p>`;
          })
          .join('');
      }
    } catch {
      // do nothing
    }
  }
  return errorDetails;
}

function fireGTMEvent(eventName, eventData = {}) {
  console.log(
    `------------------------------ Firing GTM event: ${eventName}`,
    eventData
  );
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    ecommerce: { ...eventData }
  });
}

function addTooltipOnHover(element, message = '') {
  let tooltip;

  element.addEventListener('mouseenter', function (_e) {
    tooltip = document.createElement('div');
    tooltip.innerText = message;
    tooltip.style.position = 'absolute';
    tooltip.style.background = '#333';
    tooltip.style.color = '#fff';
    tooltip.style.padding = '8px 12px';
    tooltip.style.borderRadius = '4px';
    tooltip.style.fontSize = '14px';
    tooltip.style.whiteSpace = 'pre-line';
    tooltip.style.zIndex = 9999;
    tooltip.style.pointerEvents = 'none';
    tooltip.style.boxShadow = '0 2px 8px rgba(0,0,0,0.2)';
    document.body.appendChild(tooltip);

    const rect = element.getBoundingClientRect();
    tooltip.style.left = `${
      rect.left + window.scrollX + rect.width / 2 - tooltip.offsetWidth / 2
    }px`;
    tooltip.style.top = `${
      rect.top + window.scrollY - tooltip.offsetHeight - 8
    }px`;

    requestAnimationFrame(() => {
      tooltip.style.left = `${
        rect.left + window.scrollX + rect.width / 2 - tooltip.offsetWidth / 2
      }px`;
      tooltip.style.top = `${
        rect.top + window.scrollY - tooltip.offsetHeight - 8
      }px`;
    });
  });

  element.addEventListener('mouseleave', function () {
    if (tooltip) {
      tooltip.remove();
      tooltip = null;
    }
  });
}

function generateRandomNumber(numDigits) {
  if (numDigits <= 0) {
    throw new Error('Number of digits must be greater than 0.');
  }
  const min = 10 ** (numDigits - 1);
  const max = 10 ** numDigits - 1;
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export {
  TWENTY_FOUR_HOURS_MS,
  accountGTMEventsMap,
  convertSnakeCaseToWords,
  convertCamelCaseToWords,
  sleep,
  getLocalStorageWithExpiry,
  setLocalStorageWithExpiry,
  parseErrorDetailsAsHtml,
  fireGTMEvent,
  addTooltipOnHover,
  generateRandomNumber
};
